<template>
  <v-layout wrap>
    <v-container class="hidden-sm-and-down">
      <v-layout>
        <v-flex>
          <carousel items="1" nav="false">
            <router-link to="/about"
              ><img src="@/assets/slider_about_large_2.png"
            /></router-link>
            <router-link to="/diamond-contractor"
              ><img src="@/assets/slider_diamond_contractor_large.png"
            /></router-link>
          </carousel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="d-md-none">
      <v-layout>
        <v-flex>
          <carousel items="1" nav="false">
            <router-link to="/about"
              ><img to="/about" src="@/assets/slider_about_small_2.png"
            /></router-link>
            <router-link to="/diamond-contractor"
              ><img src="@/assets/slider_diamond_contractor_small.png"
            /></router-link>
          </carousel>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-container fluid class="banner-container hidden-sm-and-down">
      <v-layout>
        <v-flex>
          <v-img class="banner-image" src="@/assets/banner.png" width="100vw" />
          <div class="about-button-large">
            <v-btn large color="primary">About Howard Mechanical</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="d-md-none">
      <v-layout>
        <div class="banner-container-small justify-center">
          <v-img
            class="banner-image"
            src="@/assets/banner_small.png"
            width="97vw"
          />
          <div class="about-button">
            <v-btn color="primary" to="/about">About Howard Mechanical</v-btn>
          </div>
        </div>
      </v-layout>
    </v-container> -->

    <v-container grid-list-md class="ac-heating-maintenance" fluid>
      <v-layout text-center>
        <v-flex>
          <div class="mt-2 section-header">
            WORRY-FREE <span style="font-weight:200">COMFORT</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout text-center row wrap class="ma-5">
        <v-flex sm4 class="my-2">
          <v-card height="100%" raised>
            <v-card-title class="justify-center">Air Conditioning</v-card-title>
            <!-- <v-card-subtitle v-text="cards[0].artist"></v-card-subtitle> -->
            <v-card-text>
              <v-icon size="45px" class="mb-5" color="primary"
                >mdi-snowflake</v-icon
              >
              <br />
              <p>
                Summers can be mild, hot and humid. On those steamy days, a
                reliable cooling system in your home can make all the
                difference. Whether you need a simple repair, cleaning, or
                complete air conditioning system make-over, our technicians at
                Howard Mechanical are equipped to handle all of your needs.
              </p>
              <v-spacer></v-spacer>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex sm4 class="my-2">
          <v-card height="100%" raised>
            <v-card-title class="justify-center">Heating</v-card-title>
            <!-- <v-card-subtitle v-text="cards[0].artist"></v-card-subtitle> -->
            <v-card-text>
              <v-icon size="45px" class="mb-5" color="red">mdi-fire</v-icon>
              <br />
              <p>
                Howard Mechanical strives to offer the highest quality of
                professionalism, timeliness, and heating service for every
                valued customer. From furnace and boiler repair to new heating
                system installation, our experts can handle any job.
              </p>
              <v-spacer></v-spacer>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex sm4 class="my-2">
          <v-card height="100%" raised>
            <v-card-title class="justify-center">Maintenance</v-card-title>
            <!-- <v-card-subtitle v-text="cards[0].artist"></v-card-subtitle> -->
            <v-card-text>
              <v-icon size="45px" class="mb-5" color="grey">mdi-tools</v-icon>
              <br />
              <p>
                Regular HVAC maintenance is a great way to save you time and
                money on Heating and cooling repairs as well as energy costs.
                Having a maintenance contract will ensure that your system is
                operating properly and will properly serve you when you need it
                most.
              </p>
              <v-spacer></v-spacer>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-container grid-list-md class="associations">
      <v-layout text-center>
        <v-flex>
          <div class="mt-2 section-header">
            DIAMOND COMMERIAL CONTRACTOR
          </div>
        </v-flex>
      </v-layout>
    </v-container> -->
    <v-container grid-list-md>
      <v-layout row justify-center text-center>
        <v-flex md4>
          <div>
            <v-img
              style="margin:auto; margin-bottom:10px"
              max-width="80%"
              src="@/assets/diamond_contractor.png"
            />
          </div>
        </v-flex>
        <v-flex md6 class="mb-5">
          <p style="color:#5e5e5e; margin: 30px; ">
            We are a proud to be recognized as an official Diamond Commercial
            Contractor. Diamond Commercial Contractors possess deep product
            knowledge, expertise and experience with Mitsubishi Electric
            systems, as demonstrated by a series of eligibility requirements and
            qualifications. As a result, Diamond Commercial Contractors are
            particularly well-suited to represent CITY MULTI® products in
            design-build, retrofit and build-to-suit project applications.
          </p>
          <div class="mb-4">
            <v-btn color="primary" to="/diamond-contractor"
              >Learn More About Diamond Contractors</v-btn
            >
          </div>
        </v-flex>
      </v-layout>
      <!-- <v-layout row justify-center text-center>
        <v-flex sm4>
          <v-btn color="primary" to="/mitsubishi">Learn More</v-btn>
        </v-flex>
      </v-layout> -->
    </v-container>
    <v-container grid-list-md fluid class="ductless">
      <v-layout text-center class="pb-5 mb-5">
        <v-flex>
          <div class="mt-2 section-header-white">
            <span style="font-weight:200">DISCOVER</span> DUCTLESS
            <span style="font-weight:200">COMFORT</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout justify-center text-center wrap>
        <v-flex md6 class="pt-5 mt-5">
          <carousel items="1">
            <img src="@/assets/ductless_1.png" />
            <img src="@/assets/ductless_2.png" />
          </carousel>
          <v-btn class="my-5" color="white" to="/ductless"
            >Ductless Solutions</v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid class="residential-services">
      <v-layout text-center>
        <v-flex>
          <div class="mt-2 section-header">
            <span style="font-weight:200">COMMON</span> RESIDENTIAL SERVICES
          </div>
        </v-flex>
      </v-layout>
      <v-layout justify-center text-center row wrap class="ma-5 pa-5 ">
        <v-flex md2 class="mb-5 pb-2"
          ><img src="@/assets/common-residential.png" />
        </v-flex>
        <v-flex md3>
          <div>Furnace Installation and Repair</div>
          <div>A/C Service</div>
          <div>Water Heaters</div>
          <div>Estimates</div>
          <div>Thermostats</div>
          <div>Heat Pumps</div>
          <div>Insulation</div>
          <div>Boilers</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid class="commercial-services">
      <v-layout text-center>
        <v-flex>
          <div class="mt-2 section-header">
            <span style="font-weight:200">COMMON</span> COMMERCIAL SERVICES
          </div>
        </v-flex>
      </v-layout>
      <v-layout justify-center text-center row wrap class="ma-5 pa-5">
        <v-flex md2 class="mb-5 pb-2"
          ><img src="@/assets/common-commercial.png" />
        </v-flex>
        <v-flex md3>
          <div>Chillers</div>
          <div>Boilers</div>
          <div>Roof Top Units</div>
          <div>Exhaust Fans</div>
          <div>Ductwork (Spiral or Custom Design)</div>
          <div>Refrigeration</div>
          <div>Fresh Air Intake (Dampers and Controls)</div>
          <div>Building Automation (Software and Controls)</div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>
<style>
.service-card {
  display: flex;
  flex-direction: column;
}
.ac-heating-maintenance {
  background-color: rgb(224, 224, 224);
}
.ac-heating-maintenance-header {
  font-size: 2rem;
}
.residential-services {
  background-color: rgb(224, 224, 224);
}
.section-header {
  font-size: 2rem;
  color: rgb(92, 92, 92);
  font-weight: 800;
}
.section-header-white {
  font-size: 2rem;
  color: rgb(255, 255, 255);
  font-weight: 800;
}
.ductless {
  background: rgb(5, 115, 196);
  background: linear-gradient(
    180deg,
    rgba(5, 115, 196, 1) 0%,
    rgba(5, 115, 196, 1) 31%,
    rgba(88, 174, 231, 1) 75%,
    rgba(5, 115, 196, 1) 100%
  );
}
.commercial-services {
  /* background-color: rgb(224, 224, 224); */
}
.banner-container {
  position: relative;
}
.banner-container-small {
  position: relative;
  text-align: center;
}
.banner-image {
  width: 100%;
}
.about-button {
  position: absolute;
  bottom: 0;
  width: 95vw;
  margin-bottom: 30px;
}
.about-button-large {
  position: absolute;
  bottom: 0;
  width: 100vw;
  margin-bottom: 4.5rem;
  margin-left: 4.5rem;
}
div.owl-nav {
  visibility: hidden;
}
</style>
<script>
// import { Carousel, Slide } from "vue-carousel";
import carousel from "vue-owl-carousel";
export default {
  components: {
    // Carousel,
    // Slide
    carousel
  },
  name: "HelloWorld",

  data: () => ({
    cards: [
      {
        color: "#1F7087",
        src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
        title: "Services",
        artist: "Foster the People"
      },
      {
        color: "#952175",
        src: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
        title: "Halcyon Days",
        artist: "Ellie Goulding"
      }
    ],
    // items: [
    //   {
    //     src: require("../assets/slider-diamond-contractor.png")
    //   },
    //   {
    //     src: require("../assets/slider-diamond-contractor.png")
    //   },
    //   {
    //     src: require("../assets/slider-diamond-contractor.png")
    //   },
    //   {
    //     src: require("../assets/slider-diamond-contractor.png")
    //   }
    // ],
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader"
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify"
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify"
      }
    ],
    importantLinks: [
      {
        text: "Documentation",
        href: "https://vuetifyjs.com"
      },
      {
        text: "Chat",
        href: "https://community.vuetifyjs.com"
      },
      {
        text: "Made with Vuetify",
        href: "https://madewithvuejs.com/vuetify"
      },
      {
        text: "Twitter",
        href: "https://twitter.com/vuetifyjs"
      },
      {
        text: "Articles",
        href: "https://medium.com/vuetify"
      }
    ],
    whatsNext: [
      {
        text: "Explore components",
        href: "https://vuetifyjs.com/components/api-explorer"
      },
      {
        text: "Select a layout",
        href: "https://vuetifyjs.com/layout/pre-defined"
      },
      {
        text: "Frequently Asked Questions",
        href: "https://vuetifyjs.com/getting-started/frequently-asked-questions"
      }
    ]
  })
};
</script>
